import BlockControls from "./block-controls";
import { BASIC_INNER_BLOCK } from '../constants';

import { __ } from "@wordpress/i18n";
import {
  RichText,
  MediaPlaceholder,
  useBlockProps,
  InnerBlocks,
} from "@wordpress/block-editor";
import React, {FC} from "react";

interface EditProps {
  attributes: {
    kicker?: string;
    headline?: string;
    imageSrc?: string;
    imageId?: number;
    imageAlt?: string;
    buttonText?: string;
    url?: string;
  };
  className: string;
  setAttributes: (attributes: Record<string, any>) => void;
  isSelected: boolean;
}

const Edit: FC<EditProps> = ({
  attributes: { headline, imageSrc, imageId, imageAlt, buttonText, url, kicker },
  setAttributes,
  isSelected,
}) => {
  const onSelectImage = (img: any) => {
    if (!img || !img.url) {
      setAttributes({ imageSrc: null, imageId: null, imageAlt: null });
      return;
    }
    setAttributes({ imageSrc: img.url, imageId: img.id, imageAlt: img.alt });
  };

  const onRemoveImage = () => {
    setAttributes({ imageSrc: null, imageId: null, imageAlt: null });
  };

  return (
    <>
      <BlockControls
        attributes={{
          kicker,
          headline,
          imageSrc,
          imageId,
          imageAlt,
          buttonText,
          url,
        }}
        onSelectImage={onSelectImage}
        onRemoveImage={onRemoveImage}
        setAttributes={setAttributes}
      />
      <div {...useBlockProps()}>
        {!imageId ? (
          <figure className="card__image">
            <MediaPlaceholder
              icon="format-image"
              labels={{
                title: __("Image", "neodigital"),
                headline: __("Image", "neodigital"),
              }}
              accept="image/*"
              onSelect={onSelectImage}
            />
          </figure>
        ) : (
          <figure className="card__image">
            <img src={imageSrc} alt={imageAlt} className={`card-image wp-image-${imageId}`} />
          </figure>
        )}
        <header className="card__header">
          {
            (kicker || isSelected) &&
            <p className="card__kicker">
              <RichText
                value={kicker}
                placeholder={__("Kicker…", "neodigital")}
                keepplaceholderonfocus="true"
                onChange={(kicker) => setAttributes({ kicker })}
              />
            </p>
          }
          <h2 className="card__title">
            <RichText
              value={headline}
              placeholder={__("Lorem ipsum…", "neodigital")}
              keepplaceholderonfocus="true"
              onChange={(headline) => setAttributes({ headline })}
            />
          </h2>
        </header>
        <div className="card__body">
          <InnerBlocks allowedBlocks={BASIC_INNER_BLOCK} />
        </div>
        <footer className="card__footer">
          <span
            aria-label={`${__('Weiterlesen auf')} ${headline}`}
            className="card__button"
          >
            <span className="card__button-label">{__('Weiterlesen')}</span> <i className="fa-solid fa-arrow-right"></i>
          </span>
        </footer>
      </div>
    </>
  );
};

export default Edit;
